module.exports = __webpack_public_path__ + "static/img/computer2.a4b6c0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-images/computer2.jpg
// module id = XD5W
// module chunks = 0